import { CmsComponentData } from '@johnlewispartnership/wtr-content-component-library';
import { createSlice } from '@reduxjs/toolkit';

type CmsContentSlice = {
  [path: string]: { locationName: string; childComponents: CmsComponentData[] }[];
};

const initialState: CmsContentSlice = {};

const cmsContentSlice = createSlice({
  name: 'waitrose/cms-content',
  initialState,
  reducers: {
    contentAdded(state, action) {
      return {
        ...state,
        [action.payload.resourcePath]: action.payload.response.content,
      };
    },
  },
});

export const { contentAdded } = cmsContentSlice.actions;
export default cmsContentSlice.reducer;
